(() => {
  angular
    .module('gm.common.gtm', [])
    .factory('GmyGtm', GmyGtm);

  function GmyGtm(
    $window,
    $log,
    Environment
  ) {
    'ngInject';

    return {
      push,
      trackModalView,
    };

    function push(dataLayer) {
      try {
        if ('dataLayer' in $window) {
          $window.dataLayer.push(dataLayer);

          if (Environment.settings && Environment.settings.log.gtm) {
            $log.debug(dataLayer);
          }
        } else {
          $log.debug('window.dataLayer not available');
        }
      } catch (e) {
        $log.debug('gtm push failed');
      }
    }

    function trackModalView(elemId) {
      push({
        pageName: `${$window.location.hash}/[vpv/modal-window/modal-${elemId}]`,
        event: 'sendVirtualPage'
      });
    }
  }
})();
